export const managersTypes = {
  loading: 'managers/loading',
  reject: 'managers/reject',
  success: 'managers/success',

  add: 'managers/add',

  edit: 'managers/edit',
};
